<div class="faq">
  <div class="faq-title" [innerHTML]="faq.title"></div>
  <div class="faq-content" [innerHTML]="faq.content"></div>
</div>
